import { userDeviceEventsByTypesAndTimeRange } from '@/api';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { useSelector } from 'react-redux';
import { useApiQuery } from './useApiQuery';

const useGetUserEvents = ({
  useruuid,
  startDate,
  endDate,
  eventTypes,
  open,
  deviceuuid,
  queryOptions,
}) => {
  const trans = useSelector(translator);
  const userEventsApi = useSelector((state) => state.apis.userEventsApi);

  return useApiQuery(
    ['getUserEvents', useruuid, deviceuuid, startDate, endDate, JSON.stringify(eventTypes)],
    () =>
      new Promise((resolve, reject) => {
        userDeviceEventsByTypesAndTimeRange(
          userEventsApi,
          {
            useruuid,
            startdatetime: startDate,
            enddatetime: endDate,
            deviceuuid: [deviceuuid],
            eventtypes: eventTypes,
          },
          apiCallback({
            translator: trans,
            successCallback: (data) => {
              resolve(data['user_events'] || []);
            },
            errorCallback: () => {
              reject([]);
            },
          })
        );
      }),
    {
      enabled:
        !!useruuid &&
        !!startDate &&
        !!endDate &&
        !!open &&
        !!deviceuuid &&
        Array.isArray(eventTypes) &&
        eventTypes.length > 0,
      ...queryOptions,
    }
  );
};

export default useGetUserEvents;
